import type { WiwState } from '@/store';

export const getPending = (state: WiwState) => {
  return state.workchat.pending;
};
